var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        {
          staticClass: "w-100",
          attrs: { "header-tag": "header" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [
                  _c("h4", { staticClass: "mb-0" }, [
                    _vm._v("Representación Gráfica / Resumen General")
                  ]),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.myCharges }
                    },
                    [_vm._v(" Mis transacciones ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("hr", { staticClass: "p-0 m-0" }),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-lg-2 col-md-4" },
              [
                _vm.totalFolders || _vm.totalFiles
                  ? _c("DoughnutChart", {
                      attrs: {
                        totalFolders: _vm.totalFolders,
                        totalFiles: _vm.totalFiles
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              {
                class: {
                  "col-12": !_vm.totalFolders && !_vm.totalFiles,
                  "col-10": _vm.totalFolders || _vm.totalFiles
                }
              },
              [
                _c("table", { staticClass: "table text-center mt-5" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Descripción")]),
                      _c("th", [_vm._v("Cantidad")])
                    ])
                  ]),
                  _c("tbody", [
                    _c("tr", [
                      _c(
                        "td",
                        [
                          _c("b-badge", { attrs: { variant: "success" } }, [
                            _vm._v("Archivos")
                          ])
                        ],
                        1
                      ),
                      _c("td", [_vm._v(" " + _vm._s(_vm.totalFiles) + " ")])
                    ]),
                    _c("tr", [
                      _c(
                        "td",
                        [
                          _c("b-badge", { attrs: { variant: "warning" } }, [
                            _vm._v("Carpetas")
                          ])
                        ],
                        1
                      ),
                      _c("td", [_vm._v(" " + _vm._s(_vm.totalFolders) + " ")])
                    ]),
                    _c("tr", [
                      _c("td", [_vm._v(" Total: ")]),
                      _c("td", [
                        _vm._v(" " + _vm._s(_vm.totalFilesPlusFolders) + " ")
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }